// Valida o NIF, usando uma função PHP
// utiliza-se evocando da seguinte forma:  $('input[name="nif"]').valida_NIF() , por exemplo
jQuery.fn.extend({
    waiting: function() {
        $(this).next('.input-loading').removeClass('input-loading-wrong');
        $(this).next('.input-loading').removeClass('input-loading-right');
        $(this).next('.input-loading').addClass('input-loading-wait-black');
        $(this).next('.input-loading').show(300);
    },

    set_Valido_NIF: function() {
        $(self).nif_correct = true;
        $(this).next('.input-loading').removeClass('input-loading-wait-black');
        $(this).next('.input-loading').removeClass('input-loading-wrong');
        $(this).next('.input-loading').addClass('input-loading-right');

    },

    set_Invalido_NIF: function() {
        $(self).nif_correct = false;
        $(this).next('.input-loading').removeClass('input-loading-wait-black');
        $(this).next('.input-loading').removeClass('input-loading-right');
        $(this).next('.input-loading').addClass('input-loading-wrong');
    },

    valida_NIF: function() {
        $(this).keyup(function() {
            //var nif = $(this).val();
            $(this).valida($(this));
        })
    },


    valida: function() {
        $(this).waiting();
        if ($(this).is_Valid()) {
            $(this).set_Valido_NIF();
        } else {
            $(this).set_Invalido_NIF();
        }

    },
    is_Valid: function() {
        // algoritmo de validação do NIF de acordo com
        // http://pt.wikipedia.org/wiki/N%C3%BAmero_de_identifica%C3%A7%C3%A3o_fiscal
        var nif = $(this).val();
        var temErro = 0;

        if (
            nif.substr(0, 1) != '1' && // pessoa singular
            nif.substr(0, 1) != '2' && // pessoa singular
            nif.substr(0, 1) != '3' && // pessoa singular
            nif.substr(0, 2) != '45' && // pessoa singular não residente
            nif.substr(0, 1) != '5' && // pessoa colectiva
            nif.substr(0, 1) != '6' && // administração pública
            nif.substr(0, 2) != '70' && // herança indivisa
            nif.substr(0, 2) != '71' && // pessoa colectiva não residente
            nif.substr(0, 2) != '72' && // fundos de investimento
            nif.substr(0, 2) != '77' && // atribuição oficiosa
            nif.substr(0, 2) != '79' && // regime excepcional
            nif.substr(0, 1) != '8' && // empresário em nome individual (extinto)
            nif.substr(0, 2) != '90' && // condominios e sociedades irregulares
            nif.substr(0, 2) != '91' && // condominios e sociedades irregulares
            nif.substr(0, 2) != '98' && // não residentes
            nif.substr(0, 2) != '99' // sociedades civis

        ) { temErro = 1; }
        var check1 = nif.substr(0, 1) * 9;
        var check2 = nif.substr(1, 1) * 8;
        var check3 = nif.substr(2, 1) * 7;
        var check4 = nif.substr(3, 1) * 6;
        var check5 = nif.substr(4, 1) * 5;
        var check6 = nif.substr(5, 1) * 4;
        var check7 = nif.substr(6, 1) * 3;
        var check8 = nif.substr(7, 1) * 2;

        var total = check1 + check2 + check3 + check4 + check5 + check6 + check7 + check8;
        var divisao = total / 11;
        var modulo11 = total - parseInt(divisao) * 11;
        if (modulo11 == 1 || modulo11 == 0) { comparador = 0; } // excepção
        else { comparador = 11 - modulo11; }


        var ultimoDigito = nif.substr(8, 1) * 1;
        if (ultimoDigito != comparador) { temErro = 1; }

        if (nif.length < 9) temErro = 1;
        return (temErro == 1) ? false : true;
    }
});


is_Numerico = function(input) {
    var RE = /^-{0,1}\d*\.{0,1}\d+$/;
    return (RE.test(input));
}


is_ValidEmail = function(emailText) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailText);
};

is_Nome = function(field_val) {
    if (field_val.match(/^[0-9]|[><\t\r\b`´@£§¨%$#"!|\\»«?^_\+\*\:;\[\{\(\}\]\)=]+/))
        return false;
    return true;
}

is_Nref = function(field_val) {
    if (field_val.match(/[><\s\t\r\b`´@£§¨\/&%$#"!|\\»«?^_\+\*\.:;,ªº\[áàãéèíìóòõúùç\]\[\{\(\}\]\)=]+/i))
        return false;
    return true;
}

is_Iva = function(field_val) {
    if (!field_val.match(/\d{1}/))
        return false;
    return true
}

is_Email = function(field_val) {
    if (!is_ValidEmail(field_val))
        return false;
    return true;
}

is_Utilizador = function(field_val) {
        if (field_val.match(/[\s*><\t\r\bçã~`´ªº\/&%$#"!|\\»«?^\-_\+\*:;,ãõóòáàíìúùéè'´`\[\{\(\}\]\)=]+/))
            return false;
        return true;
    }
    /* Foi substituida pela seguinte para permitir os crateres especiais
    is_Password=function(field_val){
    	  if(field_val.match(/[\s><\t\r\bçã~`´ªº\/&%$#"!|\\»«?^\-_\+\.:;,ãõóòáàíìúùéè'´`\[\{\(\}\]\)=]+/))
    		  return false;
    	  return true	
    }
    */

is_Password = function(field_val) {
    // substituido if (field_val.match(/[\s><\t\r\bçã`´ªº\"|\\»«^ãõóòáàíìúùéè'´`]+/))
    //if (!field_val.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[#$&*%@])([a-zA-Z0-9#$&*%@]{8,})$/))
    // Password 1 Maiúscula, 1 minúscula e um numérico
    if (!field_val.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,})$/))
        return false;
    return true
}

is_Password_Admin = function(field_val) {
    // substituido if (field_val.match(/[\s><\t\r\bçã`´ªº\"|\\»«^ãõóòáàíìúùéè'´`]+/))
    //if (!field_val.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[#$&*%@])([a-zA-Z0-9#$&*%@]{8,})$/))
    // Password 1 Maiúscula, 1 minúscula e um numérico
    if (!field_val.match(/^([a-zA-Z0-9]{4,})$/))
        return false;
    return true
}

is_Morada = function(field_val) {
    if (is_Numerico(field_val))
        return false;
    return true
}

is_Cp1 = function(field_val) {
    if (!field_val.match(/\d{4}/))
        return false;
    return true
}

is_Cp2 = function(field_val) {
    if (!field_val.match(/\d{3}/))
        return false;
    return true
}

is_Cp = function(field_val) {
    if (!field_val.match(/^[0-9]{4}(-[0-9]{3})?$/))
        return false;
    return true
}


is_Localidade = function(field_val) {
    if (field_val.match(/[><\t\r\b`´ªº@£§¨\/&%$#"!|\\»«?^\_\+\*\.:;,\[\{\(\}\]\)=0-9]+/))
        return false;
    return true;
}

is_Pais = function(field_val) {
    if (field_val.match(/[><\t\r\b`´ªº@£§¨\/&%$#"!|\\»«?^\_\+\*\.:;,\[\{\(\}\]\)=0-9]+/))
        return false;
    return true;
}


is_Distrito = function(field_val) {
    if (field_val.match(/[><\t\r\b`´@£§¨\/&%$#"!|\\»«?^\_\+\*:;,\[\{\(\}\]\)=0-9]+/))
        return false;
    return true;
}


is_Nif = function(field_val) {
    if (!field_val.match(/(^[0-9]{7,9}$)/))
        return false;
    return true;
}


is_Telefone = function(field_val) {
    field_val = field_val.replace(/\s/g, '');
    if (!field_val.match(/(^(\+[0-9]{2,3}|[0-9]{2,3})?[0-9]{9})$/))
        return false;
    return true;
}

is_Dominio = function(field_val) {
    //expmatch='/[a-z]\./';
    if (!field_val.match(/^((http:\/\/)|(https:\/\/))?[a-z0-9-.]+(\.com|\.net|\.pt|\.org|\.info|\.com\.pt|\.eu)$/))
    //				if(!field_val.match(/^([a-z0-9]+)\.([a-z0-9\-])+(\.com|\.net|\.pt|\.org|\.info|\.com\.pt|\.eu)$/))
        return false;
    return true;
}

is_Url = function(field_val) {
    //expmatch='/[a-z]\./';
    if (!field_val.match(/^((http:\/\/)|(https:\/\/))?[a-z0-9-.]+(\.com|\.net|\.pt|\.org|\.info|\.com\.pt|\.eu)(\/?)((\/)(([a-z0-9-._&\?=]+?))+)?$/))
    //				if(!field_val.match(/^([a-z0-9]+)\.([a-z0-9\-])+(\.com|\.net|\.pt|\.org|\.info|\.com\.pt|\.eu)$/))
        return false;
    return true;
}


is_Peso = function(field_val) {
    //expmatch='/[a-z]\./';
    if (!field_val.match(/^[0-9]+((,)[0-9]{3})?(\.[0-9]{1,2})?$/))
        return false;
    return true;
}

is_Preco = function(field_val) {
    //expmatch='/[a-z]\./';
    if (!field_val.match(/^[0-9]+((\.)[0-9]{3})?(,[0-9]{1,2})?$/))
        return false;
    return true;
}

is_IP = function(field_val) {
    //expmatch='/[a-z]\./';
    if (!field_val.match(/[0-9]{3}/))
        return false;
    return true;
}

is_Servidor_email = function(field_val) {
    if (!field_val.match(/^\w+\.\w+\.[a-zA-z]{1,3}$/))
        return false;
    return true;
}